import React, {Component} from 'react';
import './Loading.css';

/**
 * Loading spinner \o/
 */
class Loading extends Component {
	render() {
		return (
			<div className={`Loading ${this.props.noflex ? 'noflex' : ''}`}>
				<div className="Loading-la-line-scale-pulse-out">
					<div />
					<div />
					<div />
					<div />
					<div />
				</div>
			</div>
		);
	}
}

export default Loading;


// WEBPACK FOOTER //
// ./src/widgets/Loading.js